
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Homerenovation() {



  const cardData =
  {
    keyword: ' All Types of Home Renovation Work Services ',
    heading: 'Anjali Enterprises: All Types of Home Renovation Work Services',
    headingDescription: 'Anjali Enterprises specializes in providing a wide range of home renovation services in Pune, tailored to enhance the functionality, aesthetics, and value of your living space. Whether you are looking to remodel a single room or undertake a complete home makeover, we offer expert solutions designed to bring your vision to life.',

    topPlaces: [
        {
          title: "Home Renovation Services Pune",
          description: "Our home renovation services in Pune are designed to transform your space into a modern, functional, and stylish environment. From small updates to large-scale renovations, we handle every detail with precision to ensure quality results."
        },
        {
          title: "Home Remodeling",
          description: "Whether you want to update specific areas of your home or completely remodel your interiors, our home remodeling services are tailored to your needs. We bring innovative designs and high-quality craftsmanship to give your home a fresh new look."
        },
        {
          title: "House Renovation Services",
          description: "Anjali Enterprises offers comprehensive house renovation services, improving both the functionality and aesthetics of your home. Our team of experts works closely with you to ensure that the renovation meets your style preferences and budget."
        },
        {
          title: "Home Redesigning Work",
          description: "If you're looking to redesign your home to suit your evolving tastes or needs, our home redesigning services can help. We focus on creating spaces that reflect your personality and provide maximum comfort and convenience."
        },
        {
          title: "Kitchen Renovation",
          description: "Our kitchen renovation services are designed to create the kitchen of your dreams. Whether you're looking for more space, better functionality, or a complete redesign, we offer customized solutions that elevate the heart of your home."
        },
        {
          title: "Bathroom Renovation",
          description: "Transform your bathroom into a luxurious and functional space with our bathroom renovation services. From modern fixtures to smart layouts, we provide everything you need to create a beautiful and efficient bathroom."
        },
        {
          title: "Home Improvement Services",
          description: "Our home improvement services include a wide range of solutions aimed at enhancing the comfort, appearance, and value of your home. Whether it's updating interiors, improving energy efficiency, or adding new features, we have the expertise to handle it all."
        },
        {
          title: "Residential Renovation Services",
          description: "We specialize in residential renovation services that improve the quality and design of your home. From enhancing the layout to upgrading features, we offer personalized renovation solutions that align with your needs and preferences."
        },
        {
          title: "Home Makeover Solutions",
          description: "A home makeover can completely transform your living space. Our home makeover solutions are focused on modernizing and refreshing your home’s interiors, ensuring a seamless, stylish, and functional transformation."
        },
        {
          title: "Home Renovation Contractors Pune",
          description: "As experienced home renovation contractors in Pune, Anjali Enterprises offers reliable and affordable services for all types of residential renovations. We manage projects from start to finish, delivering exceptional results on time and within budget."
        },
        {
          title: "Full Home Renovation",
          description: "If you're considering a complete overhaul of your home, our full home renovation services are the perfect solution. We handle every aspect of the renovation, including design, construction, and finishing touches, to provide a completely transformed living space."
        },
        {
          title: "Anjali Enterprises Contact Number",
          description: "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality home renovation work. We specialize in all types of home renovation services, including remodeling, interior and exterior improvements, kitchen and bathroom renovations, and custom solutions to enhance the beauty and functionality of your home. Get in touch for expert craftsmanship and professional service. Serving Pune with top-notch home renovation work tailored to your specific needs and preferences."
        }
      ],
      tableData: [
        ["- Home renovation services in Pune", "- Home remodeling"],
        ["- House renovation services", "- Home redesigning work"],
        ["- Kitchen renovation", "- Bathroom renovation"],
        ["- Home improvement services", "- Residential renovation services"],
        ["- Home makeover solutions", "- Home renovation contractors Pune"],
        ["- Full home renovation", "- Anjali Enterprises contact number"]
      ],




    "whychoose": [
  {
    "WhyChooseheading": "Comprehensive Home Renovation Services",
    "WhyChoosedescription": "At Anjali Enterprises, we specialize in providing complete home renovation solutions to help transform your space into something truly special. Whether you're looking to update your kitchen with the latest appliances, remodel your bathroom for a modern look, or give your entire home a makeover, our team has the expertise and resources to handle all aspects of home renovation. We focus on enhancing both the aesthetics and functionality of your home, ensuring that every renovation is an investment in comfort and style."
  },
  {
    "WhyChooseheading": "Expert Design and Consultation",
    "WhyChoosedescription": "We offer professional design consultation services to help you envision the full potential of your home. Our expert designers work closely with you to understand your lifestyle, taste, and goals, creating a customized renovation plan that meets your exact needs. From space planning to selecting the right materials, we ensure that every design decision is in line with your vision, helping you create a home that reflects your personality while staying within your budget."
  },
  {
    "WhyChooseheading": "Skilled Craftsmen and Contractors",
    "WhyChoosedescription": "Our team of experienced craftsmen and contractors are committed to delivering the highest quality work on every project. We have the technical expertise to handle everything from structural changes and major renovations to intricate finishing touches. Whether it's custom cabinetry, unique flooring designs, or high-end finishes, we take pride in executing each element with precision. Our skilled professionals ensure that the final result not only looks stunning but also stands the test of time."
  },
  {
    "WhyChooseheading": "Timely Completion",
    "WhyChoosedescription": "We understand the importance of timely project completion, especially when it comes to home renovations. At Anjali Enterprises, we are committed to adhering to agreed timelines without compromising on quality. Our efficient project management ensures that your renovation progresses smoothly, with minimal disruption to your daily life. We keep you informed at every stage of the process, and our team works diligently to meet deadlines, so you can enjoy your newly renovated space sooner rather than later."
  },
  {
    "WhyChooseheading": "Customized Renovation Solutions",
    "WhyChoosedescription": "Every home is unique, and so are your renovation needs. At Anjali Enterprises, we provide highly personalized renovation solutions tailored specifically to your requirements. Whether you're looking to modernize your space with contemporary features, add functional elements for better organization, or completely overhaul your home to suit your evolving needs, we offer bespoke solutions that fit your style, needs, and budget. Our goal is to transform your living space in a way that enhances both its functionality and appeal."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "We believe in offering the best value for your investment. At Anjali Enterprises, we provide competitive pricing for all our home renovation projects without compromising on quality. We maintain full transparency in our pricing structure, offering clear and detailed quotations so you can make informed decisions. With no hidden charges or surprises, our pricing ensures that you receive top-tier service within your budget, making your home renovation project an affordable and worthwhile investment."
  },
  {
    "WhyChooseheading": "High-Quality Materials and Finishes",
    "WhyChoosedescription": "We use only the finest materials and finishes in all of our home renovation projects. From luxurious flooring and custom cabinetry to energy-efficient lighting and countertops, every material is carefully chosen for its quality, durability, and style. By selecting high-quality materials, we ensure that your renovations not only look great but also stand up to everyday wear and tear, adding long-lasting value to your home. Our attention to detail ensures that every finish complements the overall design and enhances the beauty of your space."
  },
  {
    "WhyChooseheading": "Eco-Friendly Renovations",
    "WhyChoosedescription": "At Anjali Enterprises, we are dedicated to making sustainable choices in all of our home renovation projects. We offer a wide range of eco-friendly renovation solutions, including energy-efficient appliances, water-saving fixtures, and sustainable building materials. Our team is experienced in incorporating green technologies and practices that help reduce your carbon footprint and lower your utility bills. Whether it's through energy-efficient insulation, solar panels, or recycled materials, we ensure that your home renovation not only improves your space but also contributes to a healthier environment."
  },
  {
    "WhyChooseheading": "End-to-End Service",
    "WhyChoosedescription": "Our renovation services are comprehensive and cover every aspect of your project, from the initial consultation and design phase to construction, installation, and final finishing. We handle all the details, big and small, to ensure a seamless renovation experience for you. Our team coordinates all aspects of the project, so you don’t have to worry about multiple contractors or conflicting schedules. We are dedicated to delivering a stress-free process, and we keep you updated on progress, ensuring your project is completed to your exact specifications and on time."
  }
]


  }

  const faqData = [
    {
      "question": "What types of home renovation services do you offer?",
      "answer": "We offer a wide range of home renovation services, including kitchen remodeling, bathroom renovation, living room upgrades, room additions, flooring installation, electrical and plumbing work, and more. We can handle any home renovation project you have in mind."
    },
    {
      "question": "Do you provide custom design services for home renovations?",
      "answer": "Yes, we offer custom design services to help you create a unique look and feel for your home. Our design team works with you to understand your vision and translate it into functional and beautiful renovations."
    },
    {
      "question": "How long does a home renovation project take?",
      "answer": "The duration of a home renovation project depends on the scope and complexity of the work. Typically, we provide a detailed timeline and keep you informed of progress throughout the renovation, ensuring timely completion."
    },
    {
      "question": "Can you work within my renovation budget?",
      "answer": "Yes, we are committed to working within your budget. We provide transparent pricing and offer a variety of options to fit different budgets, ensuring you get the best value for your investment."
    },
    {
      "question": "Do you handle both small and large renovation projects?",
      "answer": "Yes, we can handle renovation projects of any size, whether it's a small room makeover or a large-scale home renovation. No project is too big or small for our experienced team."
    },
    {
      "question": "Do you provide assistance with permits and approvals?",
      "answer": "Yes, we handle the paperwork and obtain the necessary permits and approvals for your home renovation project. Our team ensures that all work complies with local regulations and building codes."
    },
    {
      "question": "What kind of materials do you use in home renovations?",
      "answer": "We use high-quality materials, including premium flooring, fixtures, cabinetry, countertops, paints, and more. We offer a range of options to suit different tastes and budgets, ensuring that every material enhances the functionality and aesthetic of your home."
    },
    {
      "question": "Can you help with eco-friendly home renovations?",
      "answer": "Absolutely! We offer eco-friendly renovation options, such as energy-efficient lighting, sustainable building materials, and water-saving fixtures. We can help you make your home more energy-efficient and environmentally friendly."
    },
    {
      "question": "How do I get started with a home renovation project?",
      "answer": "You can start by contacting us for an initial consultation. We’ll discuss your ideas, assess your space, and provide a detailed plan and estimate for your renovation project. We’re here to guide you through every step of the process."
    },
    {
      "question": "Why should I choose Anjali Enterprises for my home renovation?",
      "answer": "Anjali Enterprises offers a combination of experience, expertise, and customer-centric service. We deliver high-quality, customized renovation solutions that fit your style and budget. Our commitment to timely completion, attention to detail, and transparency makes us a trusted partner for your home renovation needs."
    }
  ];
  
  const testimonials = [
    {
      "name": "Mr. Shyam Patel",
      "text": "I had Anjali Enterprises renovate my kitchen and bathroom, and the results were fantastic. The team worked closely with me on the design and kept the project on schedule. The materials used were high quality, and the final outcome exceeded my expectations!"
    },
    {
      "name": "Mrs. Neha Desai",
      "text": "I recently hired Anjali Enterprises for a full home renovation, and they did a remarkable job. The team was professional, the work was completed on time, and the renovation transformed my home into a modern and beautiful space. Highly recommended!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>



<Helmet>
  <title>Home Renovation Work Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers all types of home renovation work services in Pune, including kitchen and bathroom renovation, home redesigning, home improvement, and full home makeovers. Call +91 8793220265 for expert home renovation services." />
  <meta name="keywords" content="Home Renovation Services Pune, Home Remodeling, House Renovation Services, Home Redesigning Work, Kitchen Renovation, Bathroom Renovation, Home Improvement Services, Residential Renovation Services, Home Makeover Solutions, Home Renovation Contractors Pune, Full Home Renovation" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | Home Renovation Work Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers all types of home renovation work services in Pune, including kitchen and bathroom renovation, home redesigning, home improvement, and full home makeovers. Call +91 8793220265 for expert home renovation services." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/home-renovation-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/home-renovation-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers all types of home renovation work services in Pune, including kitchen and bathroom renovation, home redesigning, home improvement, and full home makeovers. Call +91 8793220265 for expert home renovation services.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/home-renovation-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/home-renovation-service.jpg",
        "priceRange": "₹10000 - ₹500000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/home-renovation-services",
          "priceCurrency": "INR",
          "price": "10000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.7",
          "reviewCount": "60"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi T"
            },
            "datePublished": "2024-05-15",
            "reviewBody": "Anjali Enterprises transformed our home with an amazing renovation. From the kitchen to the living room, the quality and professionalism were top-notch. Very happy with the results!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Anita D"
            },
            "datePublished": "2024-08-30",
            "reviewBody": "We hired Anjali Enterprises for our bathroom renovation. The team did an excellent job. Everything was completed on time, and the workmanship exceeded our expectations!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/home-renovation-services"
        },
        "keywords": "Home Renovation Services Pune, Home Remodeling, House Renovation Services, Home Redesigning Work, Kitchen Renovation, Bathroom Renovation, Home Improvement Services, Residential Renovation Services, Home Makeover Solutions, Home Renovation Contractors Pune, Full Home Renovation"
      }
    `}
  </script>
</Helmet>


      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/18.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Homerenovation;